<template>
	<div>
		<div class="custom-label-header">
			{{ title}} &nbsp;
			<el-tooltip :disabled="!tooltipDisabled" effect="dark"
			            :content="labelTooltip"
			            placement="top-start"
						style="float: right;margin: 5px;">
				<i class="fas fa-info-circle"></i>
			</el-tooltip>
		</div>
		<div class="custom-label-body">
			{{ body }}
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			tooltipDisabled: {

			},
			labelTooltip: {

			},
			title:{

			},
			body: {

			}
		}
	}
</script>

<style>
.custom-label-body{
/*	border: 1px solid rgb(193, 193, 193);*/
	padding: 23px 10px 10px 10px;
	word-break: break-all;
	line-height: normal;
	font-size: 14px;
}

.custom-label-header{
/*	border: 1px solid #c1c1c1;*/
	position: relative;
	width: 80%;
	padding: 0px 5px 0px 5px;
	margin: 0px 0px -18px 5px;
	background: #f7f6f6;
	word-break: break-all;
	font-size: 16px;
	font-weight: bold;
}
</style>